(function () {
  'use strict';

  document.querySelectorAll('.hsr-section').forEach(function (section) {
    var track = section.querySelector('[data-hsr-track]');
    var prevBtn = section.querySelector('[data-hsr-prev]');
    var nextBtn = section.querySelector('[data-hsr-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function cardScrollAmount() {
      var firstCard = track.querySelector('.hsr-card');
      if (!firstCard) return 280;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 20);
      return firstCard.getBoundingClientRect().width + gap;
    }

    function updateButtonState() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -cardScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: cardScrollAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtonState);
    window.addEventListener('resize', updateButtonState);
    updateButtonState();
  });
})();
